import React, { useLayoutEffect, useEffect, useRef } from 'react';
import { ErrorScreen } from 'components/common';
import { useJob } from 'components/hooks';
import withRequest from 'hoc/withRequest';
import { withRouter } from 'react-router-dom';
import { CircularProgress, Backdrop } from '@mui/material';
import JobRunWorkflowDumb from './JobRunWorkflowDumb';
import { getWFjobsId } from 'components/common/Workflow/workflowConfig';


const JobRunWorkflowSmart = (props) => {
  const { match: { params } } = props;
  const { jobId } = params;
  const { data, getJobRun, updateJobWorkflow, cleanUpMessage, isLoaded, success, error, postJobAbort } = useJob();

  const ref = useRef();


  useLayoutEffect(() => {
    getJobRun({ query: { jobId } });

    return () => cleanUpMessage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let intervalUpdate;
    intervalUpdate = setInterval(() => {
      if (data) {
        let jobs = getWFjobsId(data.ls_dependencies);
        if(data.status === 'WA' || data.status === 'RU'){
          updateJobWorkflow({ query: { jobId ,jobs} });
        }
        
      }
    }, 5000);

    return () => clearInterval(intervalUpdate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.get]);

  const handleStop = () => {
    // postJobAbort({
    //   body: { job_id: jobId }
    // });
  }


  useEffect(() => {
    getJobRun({ query: { jobId } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.post]);

  return (
    <>
      { (error.get || error.updateJob || error.post)?
        (
          <ErrorScreen />
        ): isLoaded.get || isLoaded.post ?
        (
          <Backdrop
            invisible
            sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
            open={true}
          >
            <CircularProgress color="primary" />
          </Backdrop>
        ): (data) &&
        (
          <JobRunWorkflowDumb
            data={data}
            handleStop={handleStop}
          />
        )
      }
    </>
  );
};

export default withRequest(withRouter(JobRunWorkflowSmart));
